import styled from "styled-components/macro";

export const StyledHome = styled.div`
  padding-top: 1.6rem;
  display: flex;
  flex-direction: column;
  list-style: none;
  gap: 1.6rem;
`;

export const SuccessfulMessage = styled.p`
  color: green;
  font-size: 1.6rem;
  font-weight: bold;
`;
